import axios from 'axios';
import { getAuthToken } from './auth-helper';
import { devBypassHeaders } from '@/lib/devBypass';

// Ensure VITE_API_BASE is set in your .env file with host only (no /api/v1 suffix)
// Example: VITE_API_BASE=http://localhost:8080
// The axios client adds API paths manually to avoid duplication with OpenAPI client
const VITE_API_BASE = import.meta.env.VITE_API_BASE;

const apiClient = axios.create({
  baseURL: VITE_API_BASE,
});

apiClient.interceptors.request.use(
  async (config) => {
    try {
      const token = await getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      // Security review P10b: attach the dev-bypass secret header when the
      // mock-Clerk bypass is active (no-op otherwise / in production).
      for (const [key, value] of Object.entries(devBypassHeaders())) {
        config.headers.set(key, value);
      }
    } catch (error) {
      console.error('Error fetching auth token:', error);
      // Continue with the request even if token fetching fails
      // The backend will handle authentication errors
    }
     
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Log errors in production for monitoring
    console.error('API request failed:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message
    });
    return Promise.reject(error);
  }
);

export default apiClient; 